import * as React from 'react';
import Icons from "../../Icons";

interface NonConformeProps {
  marquage: number;
}

export const NonConforme = (props: NonConformeProps) => {

    const msgNonConforme = props.marquage === 4 ? (
      <div>
        <ul className={'list-unstyled ma0'}>
          <li>- Caractère(s) inférieur(s) à 5 mm de hauteur</li>
          <li>- Ou visuel comportant plus de 8 couleurs </li>
          <li>- Ou fichier trop pixelisé pour être traité.</li>
          <li>- Ou non respect des droits d'exploitation et d'auteurs.</li>
        </ul></div>
    ) : (
      <div>
        <ul className={'list-unstyled ma0'}>
          <li>- Présence d'un dégradé vers la couleur du support </li>
          <li>- Ou élément(s) inférieur(s) à 0.35 mm</li>
          <li>- Ou fichier trop pixelisé pour être traité.</li>
          <li>- Ou non respect des droits d'exploitation et d'auteurs.</li>
        </ul></div>
    );

    return (
      <div className={'align-self-center orange flex-grow-1 order-3 order-md-1 pt2 pt-md-0 font12 nonConformeBloc'}>
        <div className={'bold text-uppercase'}><Icons icon="warning" size={20} className={'orange'} />&nbsp; FICHIER NON CONFORME</div>
        <p className={'black border-orange p-3'}>{msgNonConforme}</p>
        <p className={'black bold'} style={{letterSpacing: "-0.1px"}}>Veuillez ajouter un nouveau fichier</p>
      </div>
    )
}
